import React, { useState } from 'react';
import { Dropdown, Tooltip } from 'antd';
import TableFilterMenu from '../TableFilterMenu/TableFilterMenu';
import TableFilterBtn from '../TableFilterBtn/TableFilterBtn';

const isArraysEqual = (a = [], b = []) => {
  if (a === b) return true;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }

  return true;
};

const TableFilter = ({
  selectedItems,
  onConfirm,
  onReset,
  filterItems,
  filterMultiple,
  getPopupContainer = () => document.body,
  filtered,
}) => {
  const [visible, setVisible] = useState(false);
  const [keys, setKeys] = useState(selectedItems);

  const handleVisibleChange = (visible) => {
    if (keys?.length) {
      setKeys(selectedItems);
    }
    setVisible(visible);
  };

  const handleConfirm = () => {
    if (!isArraysEqual(selectedItems, keys)) {
      onConfirm(keys);
    }

    setVisible(false);
  };

  const handleReset = () => {
    if (selectedItems?.length) {
      onReset();
    }

    if (keys?.length) {
      setKeys([]);
    }

    setVisible(false);
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      overlay={
        <TableFilterMenu
          selectedKeys={keys || []}
          setSelectedKeys={setKeys}
          items={filterItems}
          filterMultiple={filterMultiple}
          onConfirm={handleConfirm}
          onReset={handleReset}
        />
      }
      visible={visible}
      onVisibleChange={handleVisibleChange}
      getPopupContainer={getPopupContainer}
      forceRender
    >
      <Tooltip title="Фильтр">
        <TableFilterBtn filtered={filtered} />
      </Tooltip>
    </Dropdown>
  );
};

export default TableFilter;
